// Shared "type of business" vocabulary — used by the Contact form's
// business-type dropdown and the landing page's "who we serve" trust strip,
// so the two stay in sync.
export const BUSINESS_TYPES = [
  "Café",
  "Restaurant",
  "Hotel",
  "Kontor/Erhverv",
  "Catering",
  "Supermarked",
  "Bageri",
  "Vending",
  "Andet",
];
